// @flow
import React, { Component } from 'react';
import { Input, Label, FormGroup } from 'reactstrap';

import withFlightSearchParams from '../../../HOCs/withFlightSearchParams';

import type { UpdateFlightSearchParms } from '../flowTypes';

type Props = {
  searchParams: {
    trip_type: 'R' | 'O',
  },
  updateFlightSearchParms: UpdateFlightSearchParms,
};

class FlightTypeInput extends Component<Props> {
  render() {
    let { trip_type } = this.props.searchParams;
    return (
      <div className="no-gutters">
        <div className="col-12 radio-wrap">
          <Label className="title">Trip</Label>
          <div className="row fix-align">
            <FormGroup className="col-6">
              <Label className="d-flex align-items-center">
                <Input
                  type="radio"
                  name="flightType-radio"
                  value="O"
                  checked={trip_type === 'O' ? true : false}
                  onChange={e => this.handleInputChange(e.target.value)}
                  className="flight"
                />
                <span /> One Way
              </Label>
            </FormGroup>
            <FormGroup className="col-6">
              <Label className="d-flex align-items-center">
                <Input
                  type="radio"
                  name="flightType-radio"
                  value="R"
                  checked={trip_type === 'R' ? true : false}
                  onChange={e => this.handleInputChange(e.target.value)}
                  className="flight"
                />
                <span /> Round Trip
              </Label>
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }

  handleInputChange = val => {
    const { updateFlightSearchParms } = this.props;
    updateFlightSearchParms({ parameter: 'trip_type', value: val });
  };
}

export default withFlightSearchParams(FlightTypeInput);



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/FlightTypeInput.jsx